import {
	device,
	iconSizes,
	laptopMediaQuery,
	tabletMediaQuery,
} from "@helpers";
import React, { useState } from "react";
import styled from "styled-components";
import Icon from "./Icon";

const TitleSection = styled.div<{ showDetail: boolean }>`
  display: flex;
  align-items: center;
  height: 40px;
  margin-top: 21px;
  border-radius: ${({ showDetail }) =>
		showDetail ? "0px" : "0px 0px 15px 15px"};
  padding: 0px 22px;
  justify-content: space-between;
  :hover {
    cursor: pointer;
  }

  ${tabletMediaQuery} {
    padding: 25px 45px;
  }

  @media (min-width: ${device.laptop}) {
    padding: 30px 45px;
  }
`;

const Title = styled.p`
  white-space: pre-wrap;
  font-family: var(--euclid-regular);
`;

const DetailContainer = styled.div<{ showDetail: boolean }>`
  border-radius: ${({ showDetail }) =>
		showDetail ? "0px" : "0px 0px 15px 15px"};

  > div:first-child {
    padding: 5px 20px 0px 22px;

    ${tabletMediaQuery} {
      padding: 10px 45px 0px 32px;
    }

    ${laptopMediaQuery} {
      padding: 10px 45px 0px 32px;
    }

    @media (min-width: ${device.desktopS}) {
      padding: 15px 45px 0px;
    }
  }
`;

const iconStyles = {
	cursor: "pointer",
};

const Expandable = ({
	title,
	renderDetail,
	...props
}: {
	title: string;
	renderDetail: () => JSX.Element;
}) => {
	const [expand, setExpand] = useState(false);

	const toggleExpand = () => setExpand(!expand);

	const getIconName = () => (expand ? "subtract" : "add");

	return (
		<>
			<TitleSection onClick={toggleExpand} showDetail={expand} {...props}>
				<Title>{title}</Title>
				<Icon
					iconSizes={iconSizes}
					styles={iconStyles}
					iconName={getIconName()}
					alt="expand"
				/>
			</TitleSection>
			{expand && renderDetail && (
				<DetailContainer showDetail={expand} {...props}>
					{renderDetail && renderDetail()}
				</DetailContainer>
			)}
		</>
	);
};

export default Expandable;
